import { Select } from '../../../helper/helper';

const ButtonLgClass = {
  /**
   * Add class 'btn-lg' for all button
   */
  init() {
    this._addBtnLgClass();
  },


  _addBtnLgClass() {
    const buttons = Select('.btn', true);

    buttons.forEach(button => {
      const classList = button.classList;
      const excludeButtons = [...classList].filter(el => el === 'btn-get-started' || el === 'wa-cta' || el === 'top-button' || el === "product");
      if (!excludeButtons.length) button.classList.add('btn-lg');
    });
  }
};

export default ButtonLgClass;